import React from 'react';
interface ScrollingTickerProps {
  items: string[];
}
export function ScrollingTicker({
  items
}: ScrollingTickerProps) {
  // Duplicate items for seamless infinite loop
  const duplicatedItems = [...items, ...items];
  return <div className="bg-[#0a0a0a] border-y border-white/[0.06] py-4 overflow-hidden" data-id="element-132">
      <div className="flex animate-scroll" data-id="element-133">
        {duplicatedItems.map((item, index) => <div key={index} className="flex items-center gap-3 px-8 whitespace-nowrap" data-id="element-134">
            <div className="w-2 h-2 rounded-full bg-deal-green flex-shrink-0" data-id="element-135" />
            <span className="text-white text-sm font-medium" data-id="element-136">{item}</span>
          </div>)}
      </div>
    </div>;
}